import React, { useEffect } from "react";
import {
  IonButton,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonText,
} from "@ionic/react";
import { useIntl } from "react-intl";
import { loadRecord } from "../../visit/visitSlice";
import FormWrapper from "../../visit/form/FormWrapper";

import { useSelector, useDispatch } from "react-redux";

const VisitModal = (props) => {
  const { hideModal, patientId, branchId, houseVisitsId } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  useEffect(() => {
    const params = {
      patientId,
      branchId,
      admin: false,
      houseVisitsId,
    };
    dispatch(loadRecord(params));
  }, [branchId, dispatch, houseVisitsId, patientId]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: `app.mobile.house_visit`,
            })}
          </IonTitle>

          <IonButtons slot="start">
            <IonButton
              onClick={() => {
                hideModal();
              }}
              size="default"
            >
              {intl.formatMessage({
                id: `app.mobile.actions.close`,
              })}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <FormWrapper
          hideShowPatientBtn={true}
          type="edit"
          branchId={branchId}
          patientId={patientId}
        />
      </IonContent>
    </IonPage>
  );
};

export default VisitModal;
